import {useMemo} from 'react'

import {hasAudienceTokenInUrl} from '../../offer/business/privateDeals'
import {getUrlParams} from '../../utils/url'

export const useIsAudience = () => {
  const urlParams = getUrlParams()
  return useMemo(() => hasAudienceTokenInUrl(urlParams), [urlParams?.token])
}
